export default "__VITE_ASSET__fd96f5d7__"